export default __webpack_public_path__ + "static/media/ic_app_maintenance.a9bef98a.svg";